<template>

	<div class="bodyComponente">
		<div class="cardsWrapper">
			<card-grafico texto-header="RAM" :texto-card="statusMessageRAM" :texto-footer="statusMessageRAMFooter"
				:classe-status="alertStatus(usedRAMPercentage)" />
			<card-grafico texto-header="CPU" :texto-card="statusMessageCPU" :texto-footer="statusMessageCPUFooter"
				:classe-status="alertStatus(usedCPUPercentege)" />
			<card-grafico texto-header="Armazenamento" :texto-card="statusMessageStorage"
				:texto-footer="statusMessageStorageFooter" :classe-status="alertStatus(usedDiskPercentage)" />
			<card-status texto-header="Banco de dados de Postgres" :texto-card="statusMessageSqlDb"
				:is-erro="SqlDbCheck.statusCode !== 200" texto-card-class="textoCardClassProps" />
		</div>
	</div>

</template>


<script>
	import { FetchRAMDashbord, FetchCPUDashbord, FetchStorageDashbord, FetchSqlDbDashboard } from "../services/system";
	import CardStatus from "../components/CardStatus.vue";
	import CardGrafico from "../components/CardGrafico.vue";


	export default {
		name: "SystemPage",
		components: {
			CardGrafico,
			CardStatus
		},
		data () {
			return {
				RAMCheck: { statusCode: 200, message: "", usedRAMPercentege: "" },
				usedRAMPercentage: 0,
				CPUCheck: { statusCode: 200, message: "", loadPercentage: "" },
				usedCPUPercentege: 0,
				StorageCheck: { statusCode: 200, message: "", diskUsage: "" },
				usedDiskPercentage: 0,
				SqlDbCheck: {statusCode: 200}
			};
		},
		computed: {
			statusMessageRAM () {
				if (this.RAMCheck.statusCode === 200) return this.usedRAMPercentage;
				if (this.RAMCheck.statusCode === 418) return this.usedRAMPercentage;
				return 0;
			},

			statusMessageRAMFooter () {
				if (this.RAMCheck.statusCode === 200) return `${this.RAMCheck.message}`;
				if (this.RAMCheck.statusCode === 418) return `${this.RAMCheck.message}`;
				return "Api desconectada";
			},

			statusMessageCPU () {
				if (this.CPUCheck.statusCode === 200) return this.usedCPUPercentege;
				if (this.CPUCheck.statusCode === 418) return this.usedCPUPercentege;
				return 0;
			},

			statusMessageCPUFooter () {
				if (this.CPUCheck.statusCode === 200) return `${this.CPUCheck.message}`;
				if (this.CPUCheck.statusCode === 418) return `${this.CPUCheck.message}`;
				return "Api desconectada";
			},

			statusMessageStorage () {
				if (this.StorageCheck.statusCode === 200) return this.usedDiskPercentage;
				if (this.StorageCheck.statusCode === 418) return this.usedDiskPercentage;
				return 0;
			},

			statusMessageStorageFooter () {
				if (this.StorageCheck.statusCode === 200) return `${this.StorageCheck.message}`;
				if (this.StorageCheck.statusCode === 418) return `${this.StorageCheck.message}`;
				return "Api desconectada";
			},
			statusMessageSqlDb () {
				if (this.SqlDbCheck.statusCode === 200) return "Online";
				if (this.SqlDbCheck.statusCode === 418) return "Offline";
				return " Api desconectada ";
			}

		},
		methods: {
			async RAMDashbord () {
				const data = await FetchRAMDashbord();
				this.RAMCheck = data;
				this.usedRAMPercentage = data.usedRAMPercentage;

			},

			async CPUDashbord () {
				const data = await FetchCPUDashbord();
				this.CPUCheck = data;
				this.usedCPUPercentege = data.loadPercentage;
			},

			async StorageDashbord () {
				const data = await FetchStorageDashbord();
				this.StorageCheck = data;
				const diskUsage = data.diskUsage?.replace("%", "");
				this.usedDiskPercentage = Number(diskUsage);
			},

			async SqlDbDashbord () {
				const data = await FetchSqlDbDashboard();
				this.SqlDbCheck = data;
			},

			alertStatus (percentage) {
				let corStatus = "";
				let corGrafico = "";

				if (percentage && (percentage < 80)) {
					corStatus = "card-status-ok";
					corGrafico = "#06B558";
				} else if ((80 <= percentage) && (percentage < 90)) {
					corStatus = "card-status-alert";
					corGrafico = "#faaf40";
				} else {
					corStatus = "card-status-erro";
					corGrafico = "#EC1C24";
				}

				return { corStatus, corGrafico };
			}

		},
		mounted () {
			this.RAMDashbord();
			this.CPUDashbord();
			this.StorageDashbord();
			this.SqlDbDashbord();


			this.refresh = setInterval(() => {
				this.RAMDashbord();
				this.CPUDashbord();
				this.StorageDashbord();
				this.SqlDbDashbord();
			}, 30000);
		},
		beforeDestroy () {
			clearInterval(this.refresh);
		}
	};
</script>


<style scoped>
:deep(.textoCardClassProps) {
	font-size: 11px;
}

.bodyComponente {
	width: calc(100% - 70px);
	margin-left: 70px;
	padding: 3rem 2rem;
	box-sizing: border-box;
}

.cardsWrapper {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 3rem;
	max-width: 1100px;
	margin: 0 auto;
}

.cardsWrapper>* {
	flex: 0 0 280px;
	max-width: 280px;
}
</style>